import { render, staticRenderFns } from "./Cn-COA-OilEhxto.vue?vue&type=template&id=0a1428bf&scoped=true&"
import script from "./Cn-COA-OilEhxto.vue?vue&type=script&lang=js&"
export * from "./Cn-COA-OilEhxto.vue?vue&type=script&lang=js&"
import style0 from "./Cn-COA-OilEhxto.vue?vue&type=style&index=0&id=0a1428bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1428bf",
  null
  
)

export default component.exports